import angular from 'angular';
import uiRouter from 'angular-ui-router';
import newsComponent from './news.component';
import newsListComponent from './news-list.component';
import newsDetailComponent from './news-detail.component';
import NewsService from './news.service';

let newsModule = angular.module('news', [
  uiRouter
])

.service('News', NewsService)

.config(($stateProvider, $urlRouterProvider) => {
  "ngInject";

  $urlRouterProvider.otherwise('/news');

  $stateProvider
    .state('news', {
      component: 'news'
    })
    .state('news.list', {
      url: '/news',
      component: 'newsList'
    })
    .state('news.create', {
      url: '/news/new',
      component: 'newsDetail',
      params: {
      	id: ""
      }
    })
    .state('news.edit', {
      url: '/news/:id/edit',
      component: 'newsDetail',
      params: {
        id: ""
      }
    });
})

.component('news', newsComponent)
.component('newsList', newsListComponent)
.component('newsDetail', newsDetailComponent)

.name;

export default newsModule;



// WEBPACK FOOTER //
// ./client/app/components/news/news.js